import { AI_TOOL_TYPES } from './constants'

export const AI_TOOL_FORM_PATHS = {
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: '/opportunity-engine',
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: '/film-production-analyzer',
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: '/film-budget-breakdown',
}

export const AI_TOOL_RESULTS_PATHS = {
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: '/opportunity-engine/results',
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: '/film-production-analyzer/results',
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: '/film-budget-breakdown/results',
}

export function getAiToolFormPath(toolType) {
  return AI_TOOL_FORM_PATHS[toolType] || '/'
}

export function getAiToolResultsPath(toolType) {
  return AI_TOOL_RESULTS_PATHS[toolType] || '/'
}
